import { MSG_NAME_TO_IFRAME } from '@src/container/handleIframeMessage/handleIframeMessage';

export enum EventType {
  CAMPAIGN = 'CAMPAIGN',
  EVENT = 'EVENT',
  PAGEVIEW = 'PAGEVIEW',
  ITEM = 'ITEM',
  NPS = 'NPS',
  TRANSACTION = 'TRANSACTION',
  VISITOREVENT = 'VISITOREVENT',
  SEGMENT = 'SEGMENT',
  DATALAYER = 'DATALAYER',
  BATCH = 'BATCH',
}

export type TagEvent = {
  name: MSG_NAME_TO_IFRAME.ABTastyEvent;
  type: EventType;
  qt: number;
  sen: number;
  c?: string;
  caid?: string;
  dl?: string;
  sn?: number;
  ec?: 'Action Tracking';
  ea?: string;
  t?: string;
  vaid?: string;
  ev?: number;
  path?: string;
};

export type EventFormatted = {
  type: EventType | string;
  name: string;
  campaignName?: string;
  campaignId?: number;
  triggered: number;
  path?: string;
};

export type InitialContext = {
  events: EventFormatted[];
  setSearch: (payload: string) => void;
  clear: () => void;
  addNativeToast: () => void;
};
